import SpeakerMin from './SpeakerMin'

export default SpeakerMin
// eslint-disable-next-line import/export
export * from './SpeakerMin'
